import React, {useState, useEffect} from 'react'
import db from '../firebase'
import { Row, Col } from 'react-bootstrap'
import { Project } from '../components/Project'
import { Loader } from '../components/Loader'

export const ProjectScreen = () => {
    
    const [projects, setProjects] = useState([])

    useEffect(() =>{
        db.collection('projects').orderBy('index','asc').onSnapshot(snapShot => {
            setProjects(snapShot.docs.map(doc => ({id:doc.id, project:doc.data()})))
        })
    },[])
    console.log(projects)
    
    return (<>
            {projects.length===0 
                ? <Loader style={{ margin:"auto" }}/>
                : (
                <div style={{ margin:"5rem auto" }}>
                    {typeof window==="object" && window.innerWidth<500 && <h3 data-aos="fade-down" className='mx-auto mobile_anime' style={{ width:"max-content" }}>Projects...</h3>}
                    <Row style={{ overflowX: 'hidden', width:'100%', margin:"0rem auto" }} className='pl-0 pt-5'>
                        {projects.map(project => (
                            <Col key={project.project.index} className='mx-auto mb-5'>
                                <Project 
                                    description={project.project.description.split('.')}
                                    title={project.project.title}
                                    features={project.project.features.split('.')}
                                    git={project.project.git}
                                    link={project.project.link}
                                    index={project.project.index}
                                    id={project.id}
                                    stack={project.project.stack}
                                    image={project.project.image}
                                    status={project.project.status}
                            />
                            </Col>
                        ))}
                    </Row>
                </div>
                )}
        </>
    )
}
